var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b0ae720c-25ea-4d51-81d8-083e7afd29bc",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8,12l8.6-8.6a1.9,1.9,0,0,0,0-2.8,1.9,1.9,0,0,0-2.8,0L12,9.2,3.4.6A1.9,1.9,0,0,0,.6.6a1.9,1.9,0,0,0,0,2.8L9.2,12,.6,20.6a1.9,1.9,0,0,0,0,2.8h0a1.9,1.9,0,0,0,2.8,0h0L12,14.8l8.6,8.6a1.9,1.9,0,0,0,2.8,0h0a1.9,1.9,0,0,0,0-2.8h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.95cb8e64.svg";
export { ForwardRef as ReactComponent };